var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"custom-select-box-base",attrs:{"id":_vm.id}},[_c('select',[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Select "),_vm._t("default"),_vm._v("...")],2),_vm._l((_vm.items),function(item){return _c('option',{key:item.id,domProps:{"value":item[0]}},[_vm._v("\n        "+_vm._s(item[1])+"\n      ")])})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }